import React from "react";

const Footer = () => {
        return (
            <footer className="app-footer">
                <div className="d-flex flex-row justify-content-between">
                    <span> Copyright Company Name &copy; 2018</span>
                </div>
            </footer>
        );
    }
;

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js